import { IDirective, IScope } from 'angular';
import * as Swiper from 'swiper/dist/js/swiper';
import { $Event } from '../../../helpers';

interface ISwiperScope extends IScope {
  swiper: any;
  init: ( event ) => void;
}

interface ISwiperParentScope extends IScope {
  [key: string]: any;
}

export function swiperDirective(): IDirective {
  return {
    restrict: 'A',
    scope: {
      swiper: '<',
      init: '&'
    },
    link: function postLink( scope: ISwiperScope, element ) {
      const swiper = new Swiper(element[ 0 ], scope.swiper);
      scope.init(new $Event({ swiper }));
      scope.$on('$destroy', () => {
        swiper.destroy();
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/swiper/swiper.directive.ts